import { findTableDataById } from '../Utils/Helpers';
import { useSharedContext } from '../Contexts/SharedContext';


export const useTableHook = () => {
  const { setCartDisplay } = useSharedContext();

  const updateTable = (newTable: any) => {
    const storedTable = localStorage.getItem('table')
    if (!storedTable) {
      localStorage.setItem('table', newTable);
    } else {
      const parsedTable = Number(storedTable);

      if (parsedTable !== Number(newTable)) {
        localStorage.setItem('table', newTable);
        const tables = localStorage.getItem('tables');
        if (tables) {
          const parsedTables = JSON.parse(tables);
          const objTable = findTableDataById(parsedTables, Number(newTable));
          if  (objTable) {
            const storedCartDisplay = localStorage.getItem('cart_display')
            if (storedCartDisplay) {
              let parsedCartDisplay = JSON.parse(storedCartDisplay);
              parsedCartDisplay.table = {
                id: objTable.id,
                name: objTable.name
              };
              localStorage.setItem('cart_display', JSON.stringify(parsedCartDisplay));
              setCartDisplay(parsedCartDisplay);
            }
          }
        }
      }
    }
  }
  return { updateTable };
}